module.exports = __webpack_public_path__ + "static/img/14003010.58cc5fc9.png";